import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_process_modal = _resolveComponent("ai-process-modal")!

  return (_openBlock(), _createBlock(_component_ai_process_modal, {
    mode: "generate",
    "node-type": _ctx.nodeType || 'process',
    "create-mode": true,
    busy: _ctx.creating,
    inline: _ctx.inline,
    "from-slug": _ctx.fromSlug || null,
    "initial-note": _ctx.initialNote || null,
    "initial-method": _ctx.initialMethod || null,
    ref: "modal",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    onAccept: _ctx.onAccept
  }, null, 8, ["node-type", "busy", "inline", "from-slug", "initial-note", "initial-method", "onAccept"]))
}